import { createRazorpayDonationOrder, donationPaymentCaptureAndHistoryAdd, memberProfile } from "../../AllRoutes/ApiRoute";
import CommonToast from "../../Utilities/CommonToast";
import MemberAxios from "../../Utilities/MemberAxios";


// get all customer
export const getMemberProfileAction = payload => dispatch => {
    // getting data from payload
    const { data, setMemberData } = payload
    // db operation
    MemberAxios.post(memberProfile, payload).then(res => {
        if (res.data.status == true) {
            setMemberData(res.data.data)
        }
    }).catch(err => {
        // handle loader

    })
}

export const donationPaymentCaptureAndHistoryAddAction = payload => {
    const { data } = payload
    MemberAxios.post(donationPaymentCaptureAndHistoryAdd, payload).then(res => {
        if (res.data?.status) {
            CommonToast.success(res.data?.message || "Payment successful.")
            window.location.reload()
        }
    })
}


// create donation payment order
export const createDonationPaymentOrderAction = payload => dispatch => {
    // getting payload
    const { data, Razorpay, current_pay_btn } = payload

    MemberAxios.post(createRazorpayDonationOrder, payload).then(res => {
        if (res.data?.status) {
            const options = {
                key: res?.data?.data.key,
                amount: res?.data?.data.amount * 100,
                currency: res?.data?.data.currency,
                name: "Jamia Rahmania",
                description: "Yearly donation collection",
                order_id: res?.data?.data.id,
                handler: (response) => {
                    // make donation captured and add history
                    donationPaymentCaptureAndHistoryAddAction({ data: { ...data, payment_id: response.razorpay_payment_id } })
                },
                modal: {
                    ondismiss: () => {
                        current_pay_btn.disabled = false
                    },

                },
                prefill: {
                    name: data?.member_name,
                    email: data?.email,
                    contact: data?.mobile,
                },
                theme: { color: "#00A86B" },
            };
            const razor = new Razorpay(options);
            razor.open();
        } else {
            CommonToast.error(res.data?.message || "Something went wrong")
        }
    })
}